import { Heart, Scale, Smartphone, Printer } from 'lucide-react'
import { Link } from 'react-router-dom'
import './LandingWhy.css'

const cards = [
  { icon: Heart, title: 'Erinnerungen bewahren', desc: 'Gespräche mit Verstorbenen, alten Freunden oder der Familie — für immer gesichert.', to: '/erinnerungen' },
  { icon: Scale, title: 'Rechtliche Absicherung', desc: 'Chats als Beweismittel bei Streitigkeiten, Mobbing oder rechtlichen Verfahren.', to: '/beweissicherung' },
  { icon: Smartphone, title: 'Gerätewechsel', desc: 'Neues Handy? Alle Verläufe sauber exportieren bevor du wechselst.', to: '/geraetewechsel' },
  { icon: Printer, title: 'Drucken & verschenken', desc: 'Als gedrucktes Buch, gerahmtes Bild oder persönliches Geschenk.', to: '/drucken' },
]

export function LandingWhy() {
  return (
    <section className="landing-why">
      <div className="lw-inner">
        <div className="lw-header">
          <h2 className="lw-title">Warum Menschen ChatArchiv nutzen</h2>
          <p className="lw-sub">Jede Geschichte verdient es, bewahrt zu werden</p>
        </div>
        <div className="lw-grid">
          {cards.map((c) => (
            <Link key={c.to} to={c.to} className="lw-card">
              <div className="lw-card-icon"><c.icon size={22} /></div>
              <h3 className="lw-card-title">{c.title}</h3>
              <p className="lw-card-desc">{c.desc}</p>
              <span className="lw-card-link">Mehr erfahren →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
